import axios from "../axios";

//机器人概览
export const robotOverview = (data) => {
  
    return axios({
        url: "common/query_robot_statistics",
        method: "post",
        data
    })
}
//查询机器人列表
export const queryRobotList = (data) => {
   
    return axios({
        url: "common/query_robot_list",
        method: "post",
        data
    })
}


//机器人详情
export const robotDetails = (data) => {
    return axios({
        url: "common/query_robot_detail",
        method: "post",
        data
    })
}

//修改机器人
export const modifyRobot = (data) => {
    return axios({
        url: "common/modify_robot",
        method: "post",
        data
    })
}

// 查询机器人类型
export const queryRobotType = (data)=>{
    return axios({
        url: "common/query_robot_type_list",
        method: "post",
        data
    })
}